import { connect } from 'react-redux';
import ResultTile from 'presentations/components/result_tile';

const mapStateToProps = (state) => {
  return {
    presentation: state.project.presentations.currentPresentation
  };
}

export default connect(mapStateToProps)(ResultTile);



// WEBPACK FOOTER //
// ./presentations/containers/result_tile.js